import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
// import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import axios from 'axios'
import router from '../../router'
import { Bugfender } from '@bugfender/sdk'

const state = {
  status: 'unknown',
  profile: {}
}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + 'user/whoami', data: null, method: 'GET' })
      .then(resp => {
        commit(USER_SUCCESS, resp)
        Bugfender.setDeviceKey('user', resp.data.userName)
      })
      .catch(resp => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT).then(() => {
          router.push('/login') // not working
        })
      })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, profile) => {
    state.status = 'authenticated'
    state.profile = profile.data
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
    state.profile = {}
  },
  [AUTH_LOGOUT]: (state) => {
    state.status = 'unknown'
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
